import { classNames } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './Section.scss';
/**
 * @component Section
 * @since 1.0.0
 */
export function Section(props) {
    const { style, title, infos, picto } = Object.assign({ style: 'normal' }, props);
    const className = classNames('section', 'section--' + style, props.className);
    return (React.createElement("section", { className: className },
        React.createElement("div", { className: "section-head" },
            picto && React.createElement(Icon, { className: "section-picto", value: picto }),
            title && React.createElement(Text, { className: "section-title", value: title }),
            infos && React.createElement(Text, { className: "section-infos", value: infos })),
        React.createElement("div", { className: "section-body" }, props.children)));
}
